import { ENDIF, genIdSym, IF, TPL } from 'ch4o';

const ids = genIdSym('hour', 'minute', 'second');
const tplTimeU = TPL`${ids.hour}:${ids.minute}:${ids.second}`;
const tplTimeC = TPL`${IF('hour > 0')}${ids.hour}小时${ENDIF} ${IF('minute > 0')}${ids.minute}分钟${ENDIF} ${ids.second}秒`;
/**
 * 输入秒数，返回一个包含小时、分钟和秒数的对象
 * @param [seconds=0] - 要解析的秒数。
 * @returns 具有小时、分钟和秒属性的对象。
 */
function parseTime(seconds = 0) {
    if (!(seconds >= 0)) {
        throw new SyntaxError('seconds should be positive!')
    }
    const [hour, minute, second] = [
        Math.floor(seconds / 3600),
        Math.floor(seconds / 60 % 60),
        Math.ceil(seconds % 60)
    ];

    return {
        hour: String(hour),
        minute: String(minute),
        second: String(second)
    };
}
/**
 * 格式化时间
 * @param {number} seconds 单位s
 * @returns {string}
 */
function fmtTime(seconds = 0) {
    const timeData = parseTime(seconds);


    // let fmtHour = hour > 9 ? hour : `0${hour}`;
    // let fmtMinute = minute > 9 ? minute : `0${minute}`;
    // let fmtSecond = second > 9 ? second : `0${second}`;

    // if(hour > 0) {
    //     return `${fmtHour}:${fmtMinute}:${fmtSecond}`;
    // }else {
    //     return `00:${fmtMinute}:${fmtSecond}`; 
    // }
    
    return tplTimeU(Object.entries(timeData).reduce((td, [key, value]) => {
        td[key] = value.padStart(2, '0');
        return td;
    }, {}));
}

/**
 * 格式化时间
 * @param {*} seconds 单位s
 * @returns
 */
function fmtTransTime(seconds = 0) {
    // if(val == 0) {
    //     return '0秒';
    // }
    // let hour = Math.floor(val / 3600);
    // let minute = Math.floor(val / 60 % 60);
    // let second = Math.ceil(val % 60);
    // let fmtHour = hour > 0 ? `${hour}小时` : '';
    // let fmtMinute = minute > 0 ? `${minute}分钟` : '';
    // let fmtSecond = second > 0 ? `${second}秒` : '';

    // return fmtHour + fmtMinute + fmtSecond;

    const timeData = parseTime(seconds);

    return tplTimeC(timeData);
}

/**
 * 格式化学段学科
 * @param {Array<{subjectList: Array<{subjectName: string}>, stageName: string}>} dataList 
 * @param {string} nodata 没有内容的默认显示文本
 * @returns {string}
 */
function handleStageSubject(dataList, nodata = '') {
    let stageList = dataList || [];
    let str = '';
    stageList.forEach((stageItem) => {
        let subjects = (stageItem.subjectList || stageItem.subjects)
            .map((item) => {
                return item.subjectName || item.name;
            })
            .join('，');
        str += `${stageItem.stageName}：${subjects}` + '；';
    });
    str = str.substring(0, str.length - 1);
    return str || nodata;
}

export {
    fmtTime,
    handleStageSubject,
    fmtTransTime
};
